import axiosInstance from './axiosInstance';
import axiosV2Instance from './axiosV2Instance';

export interface QuestionCommentV2 {
  id: number;
  questionId: number;
  userId: number;
  text: string;
  createdAt: string;
  isEdited: boolean;
  editedAt?: string;
  userName?: string;
  userClosed?: boolean;
  avatarUrl?: string; // URL аватарки пользователя (размер medium)
}

export interface CreateCommentRequest {
  text: string;
}

export interface UpdateCommentRequest {
  text: string;
}

class QuestionCommentsV2Api {
  /**
   * Получить комментарии к вопросу
   */
  async getQuestionComments(siteId: number, questionId: number): Promise<QuestionCommentV2[]> {
    try {
      console.log(`questionCommentsV2Api.getQuestionComments: запрос комментариев для вопроса ${questionId}`);
      const response = await axiosV2Instance.get<QuestionCommentV2[]>(`/sites/${siteId}/questions/${questionId}/comments`);
      console.log(`questionCommentsV2Api.getQuestionComments: получено ${response.data.length} комментариев`);
      return response.data;
    } catch (error) {
      console.error('Error fetching question comments:', error);
      throw error;
    }
  }

  /**
   * Добавить комментарий к вопросу
   */
  async addComment(siteId: number, questionId: number, data: CreateCommentRequest): Promise<{ id: number }> {
    try {
      console.log(`questionCommentsV2Api.addComment: добавление комментария к вопросу ${questionId}`, data);
      const response = await axiosV2Instance.post<{ id: number }>(`/sites/${siteId}/questions/${questionId}/comments`, data);
      console.log(`questionCommentsV2Api.addComment: создан комментарий с ID ${response.data.id}`);
      return response.data;
    } catch (error) {
      console.error('Error adding comment:', error);
      throw error;
    }
  }

  /**
   * Обновить комментарий
   */
  async updateComment(siteId: number, questionId: number, commentId: number, data: UpdateCommentRequest): Promise<void> {
    try {
      await axiosV2Instance.put(`/sites/${siteId}/questions/${questionId}/comments/${commentId}`, data);
    } catch (error) {
      console.error('Error updating comment:', error);
      throw error;
    }
  }

  /**
   * Удалить комментарий
   */
  async deleteComment(siteId: number, questionId: number, commentId: number): Promise<void> {
    try {
      await axiosV2Instance.delete(`/sites/${siteId}/questions/${questionId}/comments/${commentId}`);
    } catch (error) {
      console.error('Error deleting comment:', error);
      throw error;
    }
  }
}

export const questionCommentsV2Api = new QuestionCommentsV2Api();
